import React from 'react';
import { Link } from 'react-router-dom';
import Footer from '../components/Footer';
import './WikiPage.css';

const WikiPage: React.FC = () => {
  const articles = [
    {
      id: 'ai-egg-index',
      to: '/blog/ai-egg-index',
      title: 'The AI Egg Index',
      description: 'Which free AI is actually good at everyday tasks? An open-source benchmark of free-tier LLMs — why the last free leaderboard shut down, the economics of an "egg index," and why free AI needs tracking over time.',
      tag: 'Open Source',
    },
    {
      id: 'eval-methods',
      to: '/wiki/eval-methods',
      title: 'LLM Evaluation Methods',
      description: '45 evaluation methods ranked by citation count across 21 authoritative sources — from universal techniques like LLM-as-a-Judge to emerging approaches like meta-rewarding.',
      tag: '45 Methods',
    },
    {
      id: 'rag-eval',
      to: '/wiki/rag-eval',
      title: 'RAG Evaluation Methods',
      description: '23 metrics across retrieval, generation, and diagnostics — plus 5 evaluation frameworks. Covers how RAG eval extends general LLM eval with pipeline-specific concerns.',
      tag: '23 Metrics',
    },
    {
      id: 'error-margins',
      to: '/wiki/error-margins',
      title: 'Finding Your Acceptable Error Margin',
      description: 'No one will tell you what eval score is "good enough." This guide walks through the 7-step process for deriving your own thresholds — from risk classification to statistical methods.',
      tag: 'Practical Guide',
    },
  ];

  return (
    <>
      <div className="wiki-page">
        <div className="wiki-container">
          <Link to="/" className="back-link">← Back to Home</Link>

          <header className="wiki-header">
            <h1>Wiki</h1>
            <p className="wiki-description">
              Reference articles on AI engineering topics — evaluation methods, architecture patterns, and practical guides.
            </p>
          </header>

          <section className="wiki-articles">
            <div className="wiki-article-cards">
              {articles.map((article) => (
                <Link
                  key={article.id}
                  to={article.to}
                  className="wiki-article-card"
                >
                  <div className="wiki-card-header">
                    <span className="wiki-card-tag">{article.tag}</span>
                  </div>
                  <h3 className="wiki-card-title">{article.title}</h3>
                  <p className="wiki-card-description">{article.description}</p>
                  <span className="wiki-card-cta">Read Article →</span>
                </Link>
              ))}
            </div>
          </section>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default WikiPage;
